import { render } from "./BotonEgresoEmbargoGobernacionComponent.vue?vue&type=template&id=21f2fbd4"
import script from "./BotonEgresoEmbargoGobernacionComponent.vue?vue&type=script&lang=js"
export * from "./BotonEgresoEmbargoGobernacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__